import { useSettings } from "../context/SettingsContext";

const MenuTags = ({ tags }) => {
  const { settings } = useSettings();

  if (!tags || !settings?.tags?.length) return null;

  const tagIds = Array.isArray(tags)
    ? tags
    : String(tags)
        .split(",")
        .map((id) => Number(id.trim()));

  const menuTags = settings.tags.filter((tag) =>
    tagIds.includes(tag.id)
  );

  if (!menuTags.length) return null;

  return (
    <div
      className="menu-tags"
      style={{
        display: "flex",
        gap: "8px",
        flexWrap: "wrap",
        marginTop: "8px",
        marginBottom: "12px",
      }}
    >
      {menuTags.map((tag) => (
      <span
  key={tag.id}
  style={{
    backgroundColor:
      tag.background ||
      (tag.color?.toLowerCase() === "#ffffff" ||
      tag.color?.toLowerCase() === "#fff"
        ? "#000000"
        : "#eee"),

    color: tag.color || "#000",

    padding: "4px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "1",
    whiteSpace: "nowrap",
  }}
>
  {tag.name}
</span>

      ))}
    </div>
  );
};

export default MenuTags;
